/**
 * The compiler's own check that a union has been handled end to end.
 *
 * A `default` branch returning something plausible is how a third member gets
 * quietly shown the copy written for the second. Calling this from `default`
 * instead turns the omission into a build failure: the parameter is `never`, so
 * the moment a member is added every switch that does not name it stops
 * compiling, and the error names the member nobody handled.
 *
 * It throws as well, because these unions come off the wire. A runtype has
 * already refused an unknown member at the boundary, so anything reaching this
 * line is a bug in the code rather than in the payload, and a bug is better off
 * with a stack trace than with a default.
 */
export const assertNever = (value: never, context: string): never => {
  throw new Error(`${context}: unhandled ${JSON.stringify(value)}`)
}
